import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor( private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
          const token = sessionStorage.getItem(environment.tokenSessionName);
          return new HttpHeaders({
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
          });
      }
  getCalendarEvents(startDate: string, endDate: string): Observable<{ events: any[], syncErrors: any[] }> {
    const url = `${environment.envVar.API_BROADCAST}/api/calendar/events`;
    const params = new HttpParams()
      .set('start_date', startDate)
      .set('end_date', endDate);

    return this.http.get<{ events: any[], syncErrors: any[] }>(
      url,
      { headers: this.getAuthHeaders(),params }
    ).pipe(
      map(response => {
        console.log('GetCalendarEvents - Eventos obtenidos:', response);
        // Validación adicional si quieres asegurar estructura
        if (!response || !Array.isArray(response.events)) {
          throw new Error('Respuesta inesperada del servidor');
        }
        return response;
      }),
      catchError(error => {
        console.error('Error al obtener eventos del calendario:', error);

        // Puedes personalizar el mensaje que llega al componente
        return throwError(() => new Error('No se pudieron cargar los eventos del calendario. Intenta de nuevo más tarde.'));
      })
    );
  }
  // 🔹 Crear nuevo evento
  createEvent(data: any): Observable<any> {
    const url = `${environment.envVar.API_BROADCAST}/api/calendar/event`;
    return this.http.post(url, data, { headers: this.getAuthHeaders() });
  }

  // 🔹 Actualizar evento existente
  updateEvent(eventId: number | string, data: any): Observable<any> {
    const url = `${environment.envVar.API_BROADCAST}/api/calendar/event/${eventId}/update`;
    return this.http.put(url, data);
  }
}
